module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/Slice 19@2x.86e53256.png";